import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as TaskTypeActions from './actions';
import { ITask } from '@app/models/task.model';
import { environment } from 'src/environments/environment';
import { HttpService } from '@surveyname/common';


@Injectable()
export class TaskEffects {
  constructor(private http: HttpService, private action$: Actions) { }
  GetTasks$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(TaskTypeActions.GetTasksAction),
      mergeMap(action =>
        this.http.get(`${environment.apiUrl}/task`).pipe(
          map((tasks: ITask[]) => {
            return TaskTypeActions.TasksLoadedAction({ payload: tasks });
          }),
          catchError((error: Error) => {
            return of(TaskTypeActions.ErrorTasksAction(error));
          })
        )
      )
    )
  );

  CreateTask$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(TaskTypeActions.BeginCreateTaskAction),
      mergeMap(action =>
        this.http.post(`${environment.apiUrl}/task`, action.payload).pipe(
          map((task: ITask[]) => {
            return TaskTypeActions.SuccessCreateTaskAction({ payload: task });
          }),
          catchError((error: Error) => {
            return of(TaskTypeActions.ErrorTasksAction(error));
          })
        )
      )
    ),
  );

  UpdateTask$: Observable<Action> = createEffect(() =>
  this.action$.pipe(
    ofType(TaskTypeActions.BeginUpdateTaskAction),
    mergeMap(action =>
      this.http.put(`${environment.apiUrl}/task`, action.payload).pipe(
        map((task: ITask[]) => {
          return TaskTypeActions.SuccessUpdateTaskAction({ payload: task });
        }),
        catchError((error: Error) => {
          return of(TaskTypeActions.ErrorTasksAction(error));
        })
      )
    )
  ),
);
}

